<template>
  <div>
    <div class="login__main">
      <div class="login__col1">
        <div class="login__col1Body">
          <div class="login__header">
            <router-link to="/" class="login__headingImage">
              <img
                :src="require('../../assets/photos/khaanpinRed.png')"
                alt="khaanpin"
              />
            </router-link>

            <div class="login__subHeader">
              <span> FOODS . LIQUORS . CAKES</span>
              <span> 24 HOURS</span>
            </div>
          </div>

          <div v-if="loading" class="loading">
            <div><Loading /></div>
          </div>

          <div class="login__body" v-else>
            <form @submit="handleSubmit">
              <input
                placeholder=" Enter Your Phone / Email"
                autocomplete="off"
                v-model="username"
                class="login__input"
              />
              <input
                placeholder="Enter Your Password"
                type="password"
                autocomplete="off"
                v-model="password"
                class="login__input"
              />
              <button class="login__buttonSimple">Login</button>
            </form>
            <span class="login__OR"> OR</span>
            <div class="login__options">
              <form class="login__button" @click="handleGoogleLogin">
                <img :src="require('../../assets/photos/gmail.png')" />
                <button>Login with Gmail</button>
              </form>

              <form class="login__buttonfacebook" @click="handleFacebookLogin">
                <img :src="require('../../assets/photos/facebook1.png')" />
                <button>Login with Facebook</button>
              </form>

              <!-- <form class="login__button">
                <img :src="require('../../assets/photos/apple.png')" />
                <button>Login with Apple</button>
              </form> -->
              <div class="login__signup">
                <div>
                  <span> Don't have an account?</span>
                  <span>
                    <router-link to="/register" class="login__link">
                      Sign up
                    </router-link>
                  </span>
                </div>

                <span :style="{ marginTop: '6px' }">
                  <router-link to="/p/forget-password" class="login__link">
                    Forgot Password?
                  </router-link>
                </span>
              </div>
            </div>
          </div>

          <div class="login__loc">
            <span> Kathmandu </span>
            <span> /</span>
            <span> Pokhara</span>
          </div>
        </div>
      </div>

      <div class="login__col2">
        <a-carousel autoplay fade>
          <div class="login__carousel">
            <img
              :src="require('../../assets/photos/pizza.jpg')"
              alt="khaanpin"
            />
            <div class="login__imageText">
              <span>Amazing 50-50 Pizza.</span>
              <span
                >Our 50-50 pizza are the best in the town. No one can
                deny!</span
              >
            </div>
          </div>
          <div class="login__carousel">
            <img
              :src="require('../../assets/photos/chicken.jpg')"
              alt="khaanpin"
            />
            <div class="login__imageText">
              <span>Amazing 50-50 Pizza.</span>
              <span
                >Our 50-50 pizza are the best in the town. No one can
                deny!</span
              >
            </div>
          </div>
        </a-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import router from "../../router";
import {
  FacebookAuthProvider,
  signInWithPopup,
  signInWithRedirect,
  GoogleAuthProvider,
} from "firebase/auth";
import { LocationId } from "../../services/storage.service";
import { TokenService, TokenServiceApp } from "../../services/storage.service";

import { authentication } from "./FirebaseConfig";
import Loading from "../../components/Loading/Loading.vue";

export default {
  name: "Login",
  components: {
    Loading,
  },

  data() {
    return {
      username: "",
      password: "",
      userInfo: "",
      _randomPassword: "",
      loading: false,
      isloggedIn: null,
      // getData: false,
    };
  },
  computed: {
    ...mapGetters([
      "authenticationErrorCode",
      "getRegisterResponse",
      "getIsRegistered",
      "loggedIn",
      "loggedInApp",
      "locationId",
    ]),
  },

  created() {
    window.scrollTo(0, 0);
    const loggedIn = TokenService.getToken() ? true : false;
    // alert(loggedIn)
    const loggedInApp = TokenServiceApp.getToken() ? true : false;
    // alert(loggedInApp);

    if (loggedInApp || loggedIn == true) {
      router.push("/");
    }

    // console.log(this.getRegisterResponse, "register response from created");
    this._randomPassword = this.randomPassword(5, 4, 7);
    // console.log(this.randomPassword , "random")
    // alert(this.getIsRegistered);
  },
  watch: {
    // loggedInApp(val) {
    //   alert("loggedinapp");
    //   alert(val);
    //   this.isloggedIn = val;
    // },

    authenticationErrorCode: function (val) {
      if (val !== 0) {
        if (val === 400) {
          this.$notification.error({
            message: "Login failed",
            description: "Unable to log in with provided credentials.",
          });
        } else {
          this.$notification.error({
            message: "Login failed",
            description: "Login failed due to bad request.",
          });
        }
      }
    },
    getRegisterResponse: function (val) {
      // console.log(val, "register response from watch");
    },

    getData() {},

    // getRegisterResponse: function(e) {
    //   console.log(e, "hello response");
    //   if (e.error) {
    //     this.$notification.error({
    //       message: "Register failed",
    //       description: e.data,
    //     });
    //   } else {
    //     this.$notification.success({
    //       message: "Welcome " + e.data.first_name,
    //       message: "welcome",
    //       description:
    //         "Thanks for being the member of Khaanpin family. Login to continue.",
    //     });
    //     alert("login function run");
    //   }
    // },
    // userInfo: function() {
    //   alert("hello");
    //   console.log(this.userInfo, "hello userInfo");
    //   this.signUp();
    // },
  },
  mounted() {
    // console.log(this.randomPassword(4, 5, 6), "random password");
  },
  methods: {
    ...mapActions([
      "login",
      "socialRegister",
      "socialLogin",
      "loggedInApp",
      "locationId",
    ]),

    handleSubmit(e) {
      e.preventDefault();

      const value = {
        username: this.username,
        password: this.password,
      };
      this.login(value);
      // console.log(this.username, this.password, "hello testing");
    },

    handleFacebookLogin(e) {
      e.preventDefault();
      this.loading = true;

      const provider = new FacebookAuthProvider();
      signInWithPopup(authentication, provider)
        .then((res) => {
          // console.log(res._tokenResponse, "res");
          const data = res._tokenResponse;
          const value = {
            first_name: data.firstName,
            last_name: data.lastName,
            email: data.email,
            username: data.email,
            password: this._randomPassword,
            registration_source: "Web",
            sm_name: data.providerId,
            sm_id: data.localId,
            photourl: data.photourl,
          };
          // console.log(value, "facebook data");
          // this.socialRegister(value);
          // this.loading = true;

          // setTimeout(() => {
          //   this.socialLogin(value);
          //   // alert("social login");
          // }, 3000);

          this.socialRegister(value).then((response) => {
            // console.log(response, "helllo social register responseeeeeeeeeeeeee");
            if (response == true) {
              this.socialLogin(value).then((response) => {
                // console.log(response, 'hello social login responseeeeeeeeeee')
                if (response == true) {
                  router.push("/");
                } else {
                  this.socialRegister(value);
                  this.loading = false;
                }
              });
            } else {
              this.socialRegister(value);
              this.loading = false;
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    handleGoogleLogin(e) {
      e.preventDefault();
      const provider = new GoogleAuthProvider();
      signInWithPopup(authentication, provider)
        .then((res) => {
          const data = res._tokenResponse;
          const value = {
            first_name: data.firstName,
            last_name: data.lastName,
            email: data.email,
            username: data.email,
            password: this._randomPassword,
            registration_source: "Web",
            sm_name: data.providerId,
            sm_id: data.localId,
            photourl: data.photourl,
          };

          this.socialRegister(value).then((response) => {
            this.loading = true;
            if (response == true) {
              this.socialLogin(value).then((response) => {
                if (response == true) {
                  router.push("/");
                } else {
                  this.socialRegister(value);
                }
              });
            } else {
              this.socialRegister(value);
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    signUp() {
      const value = {
        first_name: this.userInfo.firstName,
        last_name: this.userInfo.lastName,
        email: this.userInfo.email,
        username: this.userInfo.email,
        password: this._randomPassword,
        registration_source: "Web",
        sm_name: this.userInfo.providerId,
        sm_id: this.userInfo.localId,
      };
      this.socialRegister(value);
    },

    randomPassword(letters, numbers, caps) {
      var chars = [
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
        "0123456789",
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
      ];

      return [letters, numbers, caps]
        .map(function (len, i) {
          return Array(len)
            .fill(chars[i])
            .map(function (x) {
              return x[Math.floor(Math.random() * x.length)];
            })
            .join("");
        })
        .concat()
        .join("")
        .split("")
        .sort(function () {
          return 0.5 - Math.random();
        })
        .join("");
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Lato:wght@400;700&family=Montserrat&family=Roboto:wght@500&display=swap");

.ant-carousel >>> .slick-slide {
  overflow: hidden;
}

.ant-carousel >>> .slick-dots li button {
  background-color: transparent;
}

.ant-carousel >>> .slick-dots li.slick-active button {
  background: transparent;
}

.login__main {
  /* border: 1px solid red; */
  display: flex;
  font-family: "Montserrat", sans-serif;
  /* height: 100vh; */
  /* background-color: red; */
}

.login__col1 {
  flex: 6;
  /* background-color: #f2f2f2; */
  background: url("../../assets/background/login.jpg") repeat-x;
  background-size: contain;
  /* border: 1px solid red; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* min-height: 50vh; */
  /* height: 100vh; */
}

.login__col1Body {
  /* border: 1px solid black; */
  padding: 7% 5%;
  background-color: #ffffffdd;
  border-radius: 12px;
  position: relative;
  /* margin: 100px 50px; */
  box-shadow: 0 0 10px 0 rgb(0 0 0 / 4%);
}

.login__col2 {
  flex: 6;

  height: 110vh;

  box-shadow: 0 3px 6px #00000029, 0 3px 6px #0000003b;
  overflow: hidden;
}
.login__carousel {
  height: 110vh;

  /* position: relative; */
}

.login__imageText {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  color: rgb(228, 228, 228);
  /* top: 50%; */
  bottom: 40%;
  width: 100%;
  padding-left: 12px;
  padding-bottom: 10px;
  /* background-image: linear-gradient(transparent, #1b1b1bdc, #020202c0); */
  /* bottom: 0%; */
}

.login__imageText > span:nth-child(1) {
  font-size: 40px;
  font-weight: bolder;
  text-shadow: 0 0 6px rgb(100, 100, 100);
}

.login__imageText > span:nth-child(2) {
  font-size: 25px;
  font-weight: bolder;
  text-shadow: 0 0 6px rgba(0, 0, 0);
}

.login__carousel > img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  box-shadow: 0 0 8px 0 rgb(0 0 0 / 10%);
  /* padding: 50px; */
}

.login__header {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login__subHeader {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
}

.login__subHeader > span {
  color: #000000;
}

.login__headingImage > img {
  height: 100px;
}

.login__header > span {
  font-size: 25px;
  font-weight: bolder;
}

.loading {
  min-height: 50vh;
  width: 50vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login__body {
  display: flex;
  flex-direction: column;
  margin: 6% 0;
}

.login__buttonSimple {
  background-color: #ed2027;
  color: #ffffff;
  border: none;
  padding: 15px 0;
  border-radius: 12px;
  font-weight: bolder;
  transition: 0.3s all;
  /* border: 1px solid black; */
  width: 100%;
}

.login__body > button:hover {
  background-color: #c20b0b;
  cursor: pointer;
}

.login__input {
  /* outline:none; */
  width: 100%;
  margin-bottom: 15px;
  padding: 0.8em 5px;
  border: 1px solid #808080;
  border-radius: 12px;
  background-color: #ffffff !important;
  outline: none;
  text-align: center;
}

.login__OR {
  text-align: center;
  margin: 20px 0;
}

::placeholder {
  color: grey;
  text-align: center;
}

.login__options {
  display: flex;
  flex-direction: column;
  /* margin: 20px 0; */
}

.login__button {
  /* width: 29rem; */
  /* background-color: red; */
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d4d4d4;
  /* margin: 5px 0; */
  margin-bottom: 18px;
  border-radius: 18px;
  padding: 10px 0;
  cursor: pointer;
  transition: 0.3s all;
}

.login__buttonfacebook {
  /* width: 29rem; */
  background-color: #3a6acc;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d4d4d4;
  /* margin: 5px 0; */
  margin-bottom: 18px;
  border-radius: 18px;
  padding: 10px 0;
  cursor: pointer;
  transition: 0.3s all;
}

.login__buttonfacebook:hover {
  background-color: #1f53bb;
}

.login__button:hover {
  background-color: #f2f2f2;
}

.login__button > img,
.login__buttonfacebook > img {
  height: 35px;
  width: 35px;
  border-radius: 15px;
}

.login__button > button {
  border: none;
  color: #000000;
  font-weight: bolder;
  background-color: transparent;
  font-size: 15px;
  margin-left: 10px;
  cursor: pointer;
}

.login__buttonfacebook > button {
  border: none;
  color: white;
  font-weight: bolder;
  background-color: transparent;
  font-size: 15px;
  margin-left: 10px;
  cursor: pointer;
}

.login__button > button:hover {
  background-color: #f2f2f2;
}

.login__signup {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.login__link {
  color: #363636;
  font-weight: bolder;
  margin-left: 5px;
  cursor: pointer;
}

.login__link:hover {
  color: #1f1f1f;
  text-decoration: underline;
}

.login__loc {
  /* border: 1px solid black; */
  text-align: center;
  position: absolute;
  bottom: 0%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.login__loc > span:nth-child(1) {
  margin-right: 5px;
}

.login__loc > span:nth-child(1):hover {
  text-decoration: underline;
  cursor: pointer;
  font-weight: bold;
}

.login__loc > span:nth-child(3) {
  margin-left: 5px;
}

.login__loc > span:nth-child(3):hover {
  text-decoration: underline;
  cursor: pointer;
  font-weight: bold;
}

@media only screen and (max-width: 1400px) {
  .login__col1 {
    background: url("../../assets/background/login.jpg") repeat-x;
    background-size: cover;
  }

  .login__headingImage > img[data-v-15717af5] {
    height: 83px;
  }

  .login__col1Body {
    padding: 5% 6%;
    margin: 0.5% 0;
  }
  .login__body > input {
    /* outline: none; */
    width: 18rem;
  }

  .login__OR {
    text-align: center;
    margin: 6px 0;
  }

  .login__button {
    padding: 7px 0;
    border-radius: 10px;
  }

  .login__buttonfacebook {
    /* margin: 5px 0; */
    border-radius: 10px;
    padding: 8px 0;
  }

  .login__button > img,
  .login__buttonfacebook > img {
    height: 29px;
    width: 28px;
    border-radius: 12px;
  }

  .login__body > button {
    padding: 14px 0;
  }

  .login__imageText > span:nth-child(1) {
    font-size: 35px;
    font-weight: bolder;
    /* text-transform: uppercase; */
  }

  .login__imageText > span:nth-child(2) {
    font-size: 18px;
  }

  @media only screen and (max-width: 850px) {
    .login__col2 {
      display: none;
    }

    .login__col1Body {
      padding: 5% 8%;
    }

    .login__body > input {
      /* outline: none; */
      width: 15rem;
    }

    .login__button {
      margin-bottom: 15px;
    }
    .login__headingImage > img {
      height: 66px;
    }
  }
}
</style>
